export default {"src":"/_next/static/media/noodles.77c355d7.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};